require("./data-carousel.scss");
require("./owl.carousel.css");
require("./owl.carousel.min.js");
require('@carsales-private/editors-rating');

(function () {
    $(document).ready(function () {

        $(".owl-carousel").not(".two-column-owl").not(" .three-column-owl,three-tiles-owl")
            .not(".three-tiles-owl").each(function (i, carousel) {
        
            var carouselItemCount = $(`#${carousel.id}`).children('.card').length;
            var minCardsReqForNav = 4;
            var isLoopEnabled = true;
            var isRewindEnabled = true;
            
            var navClasses = `.owl-theme .custom-nav.${carousel.id}-nav`;
          
            if (carouselItemCount <= minCardsReqForNav) {
                navClasses = "";
                isLoopEnabled = false;
                isRewindEnabled = false;
            }
          
            $(this).owlCarousel({
            loop: isLoopEnabled,
            margin: 15,
            rewind: isRewindEnabled,
            navText: [],
            navContainer: navClasses,
            responsiveClass: true,
            lazyLoad: true,
            navSpeed: 125,
            responsive: {
              0: {
                items: 2,
                nav: false,
                slideBy: 2
              },
              768: {
                items: 3,
                nav: false,
                slideBy: 3
              },
              992: {
                items: minCardsReqForNav,
                nav: true,
                smartSpeed: 600,
                slideBy: 4
              }
                }
          });
          
            $('.data-carousel .owl-theme .owl-dot span').addClass('bg-primary');
            $('.owl-prev').attr('data-webm-clickvalue', 'back');
            $('.owl-next').attr('data-webm-clickvalue', 'next');
        });

    });
})();